import { CheckCircle, Prohibit } from '@phosphor-icons/react';
import Modal from '../../../../../shared/components/Modal';
import OnlineAvatar from '../../../../../shared/components/OnlineAvatar';
import { formatDate } from '../../../../../shared/utils/date';

type UserModalProps = {
  user: any;
  now: number;
  t: any;
  onClose: () => void;
  onToggleBan: (user: any) => Promise<boolean>;
};

export default function UserModal({
  user,
  now,
  t,
  onClose,
  onToggleBan,
}: UserModalProps) {
  return (
    <Modal onClose={onClose}>
      <div className="user-modal">
        <OnlineAvatar user={user} size={82} now={now} />
        <h2>{user.firstName} {user.lastName}</h2>
        <p>@{user.username}</p>
        <div>
          <span>{t.email}<b>{user.email}</b></span>
          <span>
            {t.lastLogin}
            <b>{formatDate(user.lastLogin, t.locale)}</b>
          </span>
        </div>
        <button
          className={user.banned ? 'primary full' : 'danger full'}
          onClick={() => onToggleBan(user)}
        >
          {user.banned ? <><CheckCircle />{t.unbanUser}</> : <><Prohibit />{t.banUser}</>}
        </button>
      </div>
    </Modal>
  );
}
